import { tv } from '~/utils/tv'

export const inputTextActionsVariants = tv({
  base: `
    group flex w-[100%] items-center justify-between gap-onepulse py-threepulse duration-100 ease-in
    bg-forms-fill-filled ring-forms-border-filled ring-quarterpulse overflow-hidden
    focus-within:ring-halfpulse focus-within:bg-forms-fill-focused min-w-[calc(var(--sizing-huge)_+_var(--sizing-tiny))]
    `,
  variants: {
    size: {
      md: 'h-medium rounded-form px-twopulse',
      ml: 'h-mediumlarge rounded-form px-threepulse',
      lg: 'h-large rounded-form px-threepulse',
      xl: 'h-extralarge rounded-largecontainer px-threepulse',
    },
    hasError: {
      true: 'ring-forms-border-error',
    },
    readOnly: {
      true: '',
    },
    disabled: {
      true: 'cursor-not-allowed ring-forms-border-disabled ring-quarterpulse',
    },
  },
  compoundVariants: [
    {
      readOnly: false,
      disabled: false,
      class: `
        [&:not(:focus-within)]:has-[:placeholder-shown]:bg-forms-fill
        [&:not(:focus-within)]:has-[:placeholder-shown]:hover:bg-forms-fill-hovered
      `,
    },
    {
      hasError: false,
      readOnly: false,
      disabled: false,
      class: `
          focus-within:ring-action-border-focused hover:ring-halfpulse
          [&:not(:focus-within)]:has-[:placeholder-shown]:ring-forms-border
          [&:not(:focus-within)]:has-[:placeholder-shown]:hover:ring-forms-border-hovered
          [&:not(:focus-within)]:has-[:placeholder-shown]:ring-none
        `,
    },
    {
      readOnly: true,
      disabled: false,
      class:
        'cursor-not-allowed bg-forms-fill-readonly ring-forms-border-readonly ring-quarterpulse',
    },
  ],
  defaultVariants: {
    size: 'ml',
    isFocused: false,
    hasError: false,
    readOnly: false,
    disabled: false,
  },
})
